export function getMultiLineYAxisConfig(
  chartData: any[],
  dataKeys: string[],
  fallbackDomain: [number, number] = [0, 100],
) {
  const yValues = chartData
    .flatMap((item: any) =>
      dataKeys
        .map((key) => item?.[key])
        .filter((value) => typeof value === "number" && !isNaN(value)),
    )
    .filter((value) => typeof value === "number" && !isNaN(value));
  if (!yValues.length) {
    const [min, max] = fallbackDomain;
    const step = (max - min) / 5;
    return {
      domain: fallbackDomain,
      ticks: Array.from({ length: 6 }, (_, index) => min + step * index),
    };
  }
  let min = Math.min(...yValues);
  let max = Math.max(...yValues);
  if (min === max) {
    const pad = min === 0 ? 10 : Math.max(Math.abs(min) * 0.1, 5);
    min -= pad;
    max += pad;
  }
  const range = max - min;
  const roughStep = range / 5;
  const safeStep = roughStep > 0 ? roughStep : 10;
  const magnitude = Math.pow(10, Math.floor(Math.log10(safeStep)));
  const normalized = safeStep / magnitude;
  let niceNormalized = 10;
  if (normalized <= 1) niceNormalized = 1;
  else if (normalized <= 2) niceNormalized = 2;
  else if (normalized <= 5) niceNormalized = 5;
  const step = niceNormalized * magnitude;
  const domainMin = Math.floor(min / step) * step;
  const domainMax = Math.ceil(max / step) * step;
  const ticks: number[] = [];
  for (let tick = domainMin; tick <= domainMax + step / 2; tick += step) {
    ticks.push(Number(tick.toFixed(6)));
  }
  return {
    domain: [domainMin, domainMax] as [number, number],
    ticks,
  };
}
